import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export const ForWhoSection = () => {
  const isFor = ['Sos profesional independiente, freelancer o prestador de servicios en Argentina', 'Tenés experiencia pero hoy no generás las ventas que necesitás', 'Mandás presupuestos que no se cierran o tenés clientes que desaparecen', 'Querés un sistema concreto y no más teoría motivacional', 'Estás dispuesto a aplicar el plan esta misma semana', 'Trabajás en diseño, marketing, contabilidad, arquitectura, derecho, salud, educación, consultoría o cualquier rubro de servicios'];
  const notFor = ['Esperás resultados sin hacer nada', 'Vendés productos físicos en un local', 'Buscás un curso largo con certificado', 'No estás dispuesto a cambiar cómo presentás tu oferta', 'Creés que el mercado se recupera solo y solo hay que esperar'];
  return <section className="py-24 bg-cream" data-id="element-120">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-123">
            ¿Esto es para vos?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-124">
          {/* Es para vos */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-600 rounded-xl p-8 shadow-md" data-id="element-125">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-126">
              <CheckCircle2 className="w-8 h-8 text-white" data-id="element-127" />
              CAJA DE COBRO es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-128">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-50" data-id="element-129">
                  <span className="text-white mt-1" data-id="element-130">✅</span>
                  <span className="text-lg leading-snug" data-id="element-131">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO es para vos */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-8 border border-neutral-200 shadow-sm" data-id="element-132">
            <h3 className="text-2xl font-bold text-neutral-700 mb-8 flex items-center gap-3" data-id="element-133">
              <XCircle className="w-8 h-8 text-neutral-400" data-id="element-134" />
              CAJA DE COBRO NO es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-135">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-neutral-600" data-id="element-136">
                  <span className="text-neutral-400 mt-1" data-id="element-137">❌</span>
                  <span className="text-lg leading-snug" data-id="element-138">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};